import { cn } from "@/common/utils/cn";
import { forwardRef, Ref } from "react";

interface PrintContextProps {
  content: string;
  backgroundColor: string;
  color: string;
  className?: string;
}

const PrintContext = forwardRef(({ content, backgroundColor, color, className }: PrintContextProps, ref) => {
  return (
    <div
      ref={ref as Ref<HTMLDivElement>}
      className={cn(
        'hidden print:flex print:justify-center w-full font-mono',
        `bg-[${backgroundColor}] text-[${color}]`,
        className,
      )}
      style={{
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word',
        overflowWrap: 'break-word'
      }}
    >
      <div style={{ maxWidth: '100%', minWidth: 0 }}>
        {content}
      </div>
    </div>
  )
})

export default PrintContext;
